import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import * as pages from '../../core/routing/page-names';
import { EmailSettingsComponent } from "./email-settings/email-settings.component";
import { AdminGuard } from "src/app/base/guards/admin.guard";

const routes: Routes = [
  {
    path: pages.settingsPageName,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: pages.emailSettingsPageName
      },
      {
        path: pages.emailSettingsPageName,
        component: EmailSettingsComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule { }